import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const TableRowRecord = Record({
  id: null,
  type: null,
  index: null,
  cells: List(),
  top: null,
  height: null,
  parentRowId: null,
  indentationLevel: 0,
  hasChildren: false,
  childrenExpanded: false,
  isFiltered: false,
  hasViolatedConstraints: false
});

const data = {
  collections: {
    cells: "TableCellRecord"
  }
};
createFromJS.registerCallback("TableRowRecord", createFromJS.createNestedCallback(TableRowRecord, data));
